import { useState } from "react";
import { HiMenu } from "react-icons/hi";
import { NavLink } from "react-router-dom";
import { IoMdCloseCircle } from "react-icons/io";
import { FaAngleDown, FaFilm } from "react-icons/fa6";
import "./mobileHeader.css";
import { useTheme } from "../../context/ThemeContext";

const MobileHeader = ({
  isOpen,
  setIsOpen,
  navItems,
  user,
  onLogout,
  onNavigate,
  onOpenFilmModal,
}) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const { theme, toggleTheme } = useTheme();

  const toggleDropdown = (id) => {
    setOpenDropdown(openDropdown === id ? null : id);
  };

  return (
    <div className="d-lg-none no-scroll d-flex align-items-center gap-2">
      {onOpenFilmModal && (
        <button
          className="watch-film-trigger-btn py-1 px-3 me-1"
          style={{ fontSize: "0.78rem" }}
          onClick={onOpenFilmModal}
          title="Watch Short Film"
        >
          <FaFilm /> Watch Film
        </button>
      )}

      {isOpen ? (
        <IoMdCloseCircle size={30} onClick={() => setIsOpen(false)} />
      ) : (
        <HiMenu size={30} onClick={() => setIsOpen(true)} />
      )}

      <nav className={`mobile-menu ${isOpen ? "show" : ""}`}>
        <ul>
          {onOpenFilmModal && (
            <li style={{ padding: "0.5rem 0" }}>
              <button
                className="watch-film-trigger-btn"
                onClick={() => {
                  onOpenFilmModal();
                  setIsOpen(false);
                }}
                style={{ width: "100%", justifyContent: "center" }}
              >
                <FaFilm /> Watch Short Film
              </button>
            </li>
          )}
          {navItems.map((item) => {
            if (item.show === false) return null;

            return (
              <li key={item.id}>
                {!item.dropdown ? (
                  <span
                    className="mobile-link"
                    onClick={() => {
                      onNavigate(item);
                      setIsOpen(false);
                    }}>
                    {item.label}
                  </span>
                ) : (
                  <>
                    <div
                      className="nav-item"
                      onClick={() => toggleDropdown(item.id)}>
                      <span>{item.label}</span>
                      <FaAngleDown
                        className={`suboptions-icon ${
                          openDropdown === item.id ? "rotated" : ""
                        }`}
                      />
                    </div>

                    <ul
                      className={`suboptions ${
                        openDropdown === item.id ? "show" : ""
                      }`}>
                      {item.items.map((sub) => (
                        <li key={sub.path}>
                          <NavLink
                            to={sub.path}
                            onClick={() => setIsOpen(false)}>
                            {sub.label}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </li>
            );
          })}

          {/* Auth */}
          <li>
            {user ? (
              <button className="logout-btn" onClick={onLogout}>
                Logout
              </button>
            ) : (
              <NavLink to="/login" onClick={() => setIsOpen(false)}>
                Login / Register
              </NavLink>
            )}
          </li>
          {/* Theme Toggle */}
          <li style={{ padding: "0.5rem 0" }}>
            <button
              className="theme-toggle-btn"
              onClick={toggleTheme}
              style={{ width: "100%", borderRadius: 10, padding: "0.5rem", justifyContent: "center", gap: 8, display: "flex", alignItems: "center", fontSize: "0.9rem" }}
            >
              {theme === "dark" ? "☀️  Switch to Light" : "🌙  Switch to Dark"}
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default MobileHeader;
